﻿import DoneIcon from "@mui/icons-material/Done";
import Info from "@mui/icons-material/ErrorOutlineSharp";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import {
  Avatar,
  Box,
  Grid,
  IconButton,
  LinearProgress,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import React from "react";

function ClientSiteFilingProgressComponent(props) {
  const { data } = props;

  const UPLOADING_COLOR = "#4E46E7";
  const UPLOADED = "#48C35C";
  const REJECTED = "#F23E5E";

  const ListingCard = ({ item, index }) => {
    const color =
      item?.status == 201
        ? UPLOADED
        : item?.error == "Network Error"
          ? REJECTED
          : UPLOADING_COLOR;
    return (
      <Grid
        key={index}
        size={12}
        sx={{
          padding: "10px",
          width: "100%",
          backgroundColor: "white",
          border: "2px solid ",
          borderColor: color,
          borderRadius: "10px",
        }}
      >
        <Stack sx={{ gap: 1,  display: "flex", alignItems: "center"  }} direction="row" >
          <Avatar
            sx={{
              background: "#EEF2FE",

              width: "50px",
              height: "50px",
            }}
          >
            <UploadFileIcon
              sx={{
                color: color,
              }}
            />
          </Avatar>
          <Stack spacing={0.5} width={"100%"}>
            <Stack sx={{ display: "flex",  alignItems: "center", justifyContent: "space-between" }}  direction={"row"} width={"100%"}>
              <Typography sx={{ fontWeight: "bold" }}>{item?.fileName}</Typography>
              {item?.error == "Network Error" && (
                <Tooltip title={<Typography>{item?.error}</Typography>}>
                  <IconButton
                    sx={{
                      height: "25px",
                      width: "25px",
                    }}
                  >
                    <Info
                      sx={{
                        fontSize: "25px",
                        color: REJECTED,
                      }}
                    />
                  </IconButton>
                </Tooltip>
              )}
              {item?.status == 201 && (
                <IconButton
                  sx={{
                    background: UPLOADED,
                    height: "25px",
                    width: "25px",
                  }}
                >
                  <DoneIcon
                    sx={{
                      fontSize: "20px",
                      color: "white",
                    }}
                  />
                </IconButton>
              )}
            </Stack>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Box sx={{ width: "100%", mr: 1 }}>
                <LinearProgress
                  sx={{
                    height: 5,
                    borderRadius: 5,
                    "& .MuiLinearProgress-bar": {
                      backgroundColor: color,
                    },
                  }}
                  variant="determinate"
                  value={item?.progress}
                />
              </Box>
              <Box sx={{ minWidth: 35 }}>
                <Typography variant="body2" sx={{ color: "text.secondary" }}>
                  {`${Math.round(item?.progress)}%`}
                </Typography>
              </Box>
            </Box>
          </Stack>
        </Stack>
      </Grid>
    );
  };

  return (
    <>
      <Grid
        container
        spacing={1}
        sx={{
          scrollbarWidth: "none",
          maxHeight: "500px",
          overflow: "scroll",
        }}
      >
        {data?.map((item, index) => (
          <ListingCard index={index} key={index} item={item} />
        ))}
      </Grid>
    </>
  );
}

export default ClientSiteFilingProgressComponent;

